import React from 'react';
import { architecture } from '../data/architecture';
import { SectionHeading } from './ui/SectionHeading';
import { Card } from './ui/Card';
import { Tag } from './ui/Tag';
import { Reveal } from '../lib/motion';
import { Icon } from '../lib/Icon';

export default function Architecture() {
  return (
    <section
      id="arquitetura"
      style={{
        padding: 'var(--section-pad-y) clamp(20px,5vw,56px)',
        background: 'var(--bg-recessed)',
        borderTop: '1px solid var(--border-subtle)',
        borderBottom: '1px solid var(--border-subtle)',
      }}
    >
      <div style={{ maxWidth: 'var(--container-wide)', margin: '0 auto' }}>
        <Reveal>
          <SectionHeading index="05" eyebrow="Arquitetura" title="Como eu penso sistemas" />
        </Reveal>
        <Reveal delay={80}>
          <p style={{ maxWidth: 'var(--container-prose)', marginTop: 20, fontSize: 'var(--text-lg)', lineHeight: 1.6, color: 'var(--text-secondary)' }}>
            Não basta funcionar — tem que sustentar escala, mudar sem quebrar e ser legível pelo próximo dev.
            Desenho domínio e infraestrutura separados, e escalo com mensageria e processamento assíncrono.
          </p>
        </Reveal>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: 18,
            marginTop: 48,
          }}
        >
          {architecture.map((group, i) => (
            <Reveal key={group.title} delay={i * 80} style={{ display: 'flex' }}>
              <Card style={{ height: '100%' }} padding="28px">
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 16 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 44,
                        height: 44,
                        borderRadius: 'var(--radius-md)',
                        background: 'var(--yellow-a08)',
                        border: '1px solid var(--yellow-a16)',
                        color: 'var(--accent)',
                        flexShrink: 0,
                      }}
                    >
                      <Icon name={group.icon} size={22} />
                    </span>
                    <h3 style={{ fontSize: 'var(--text-h3)', margin: 0 }}>{group.title}</h3>
                  </div>
                  <p style={{ color: 'var(--text-secondary)', fontSize: 14.5, lineHeight: 1.6, margin: 0 }}>
                    {group.blurb}
                  </p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 'auto' }}>
                    {group.items.map((it) => (
                      <Tag key={it} size="sm" variant="muted">{it}</Tag>
                    ))}
                  </div>
                </div>
              </Card>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
